export const CANCELLED_MESSAGE =
    "The user cancelled this step and does not want to continue right now. Do NOT call this tool, or any other " +
    "tool, again automatically — that includes retrying with different arguments. Send a short plain-text chat " +
    "message acknowledging the cancellation, then stop and wait for the user's next message before taking any " +
    "further action.";

export const buildCancelledResponse = (extra: Record<string, unknown> = {}): string =>
    JSON.stringify({ status: "cancelled", message: CANCELLED_MESSAGE, ...extra });
